import { useParams } from 'react-router-dom';
import { CityRoutingParam } from '../infrastructure/commonTypes';

export const useCityParam = () => useParams<Partial<CityRoutingParam>>();
